
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $fdaf2b585cf7a8ba$var$ANIMATION_SETTINGS = {
    DURATION: Infinity,
    FPS: 24,
    SPEED: 1,
    UPDATE_INTERVAL: 1000 / 24
};
class $fdaf2b585cf7a8ba$export$1f1fba5c4d5199c6 {
    constructor(){
        this.lastFrameTime = 0;
        this.timeSinceLastUpdate = 0;
        this.pauseStartTime = 0;
        this.totalPausedTime = 0;
        this.frame = 0;
        this.isPaused = false;
        this.req = null;
        this.fpsUpdateInterval = 200; // Update FPS every 500ms
        this.lastFpsUpdate = 0;
        this.framesSinceLastUpdate = 0;
        this.currentFps = 0;
    }
    reset() {
        this.lastFrameTime = 0;
        this.timeSinceLastUpdate = 0;
        this.totalPausedTime = 0;
        this.pauseStartTime = 0;
        if (this.req) cancelAnimationFrame(this.req);
        this.lastFpsUpdate = 0;
        this.framesSinceLastUpdate = 0;
        this.currentFps = 0;
    }
    prepareFrame(currentTime) {
        if (!this.lastFrameTime) this.lastFrameTime = currentTime;
        // Adjust currentTime by subtracting total paused time
        const adjustedTime = currentTime - this.totalPausedTime;
        const secondsElapsed = adjustedTime / 1000;
        if (secondsElapsed > $fdaf2b585cf7a8ba$var$ANIMATION_SETTINGS.DURATION) return false;
        if (!this.isPaused) {
            if (this.pauseStartTime > 0) {
                // Coming out of pause - update total paused time
                this.totalPausedTime += currentTime - this.pauseStartTime;
                this.pauseStartTime = 0;
            }
            const deltaTime = (currentTime - this.lastFrameTime) * $fdaf2b585cf7a8ba$var$ANIMATION_SETTINGS.SPEED;
            this.timeSinceLastUpdate += deltaTime;
            this.lastFrameTime = currentTime;
        } else if (this.pauseStartTime === 0) // Just paused - record the pause start time
        this.pauseStartTime = currentTime;
        // Calculate FPS
        this.framesSinceLastUpdate++;
        if (currentTime - this.lastFpsUpdate >= this.fpsUpdateInterval) {
            this.currentFps = Math.round(this.framesSinceLastUpdate * 1000 / (currentTime - this.lastFpsUpdate));
            this.framesSinceLastUpdate = 0;
            this.lastFpsUpdate = currentTime;
        }
        let steps = 0;
        if (!this.isPaused) steps = Math.floor(this.timeSinceLastUpdate / $fdaf2b585cf7a8ba$var$ANIMATION_SETTINGS.UPDATE_INTERVAL);
        return {
            steps: steps,
            adjustedTime: adjustedTime
        };
    }
    postUpdate(steps) {
        this.frame += steps;
        this.timeSinceLastUpdate -= steps * $fdaf2b585cf7a8ba$var$ANIMATION_SETTINGS.UPDATE_INTERVAL;
    }
    togglePlayPause() {
        this.isPaused = !this.isPaused;
        if (!this.isPaused) {
            // Reset timing variables when unpausing
            this.lastFrameTime = 0;
            this.timeSinceLastUpdate = 0;
        }
    }
}


function $300d32803541d4a4$export$b3d4e64778df73ab(river, w) {
    const points = river.x.map((x, i)=>[
            x,
            river.y[i]
        ]);
    const channels = [
        {
            l: [],
            r: []
        },
        {
            l: [],
            r: []
        },
        []
    ];
    const widths = points.map(([x, y])=>{
        const top = window.terrain.width(x, y);
        const bottom = window.terrain.width(x - 20, y);
        return {
            top: top,
            bottom: bottom,
            total: top + bottom
        };
    });
    const splitAt = 8;
    const minGap = 0.4;
    const maxGap = 1.5;
    let gaps = widths.map((w, i)=>{
        const [x, y] = points[i];
        // Terrain noise is deterministic per world position — no frame-to-frame flicker
        const n = window.terrain.noise2D(x / 400 + 100, y / 400 + 100);
        if (n > 0.2) {
            const gap = Math.min(maxGap, w.total - splitAt);
            if (gap < minGap) return 0;
            return gap;
        }
        return 0;
    });
    const N = 3;
    // Precompute sequence boundaries in a single pass
    const seqStart = new Array(gaps.length);
    const seqEnd = new Array(gaps.length);
    let runStart = -1;
    for(let i = 0; i < gaps.length; i++){
        if (gaps[i] >= minGap) {
            if (runStart === -1) runStart = i;
        } else if (runStart !== -1) {
            for(let j = runStart; j < i; j++){
                seqStart[j] = runStart;
                seqEnd[j] = i - 1;
            }
            runStart = -1;
        }
    }
    if (runStart !== -1) for(let j = runStart; j < gaps.length; j++){
        seqStart[j] = runStart;
        seqEnd[j] = gaps.length - 1;
    }
    gaps = gaps.map((gap, i)=>{
        if (i < N || i >= gaps.length - N) return 0;
        if (gap < minGap) return 0;
        // Find the start and end of the continuous sequence first
        const start = seqStart[i];
        const end = seqEnd[i];
        // Check if sequence is long enough
        if (end - start + 1 < N * 2) return 0;
        // Calculate position within the sequence (0 to 1)
        const position = (i - start) / (end - start);
        // Create almond shape using sine function
        // const almondShape = Math.sin(Math.PI * position) * gap;
        // More pointed almond (using power function)
        // const almondShape = Math.pow(Math.sin(Math.PI * position), 0.7) * gap;
        // Wider middle (using cosine)
        // const almondShape = ((1 - Math.cos(Math.PI * position)) * gap) / 2;
        // Asymmetric almond (shifts the peak)
        // const almondShape = Math.sin(Math.PI * Math.pow(position, 1.2)) * gap;
        const teardropShape = Math.sin(Math.PI * Math.pow(position, 0.7)) * gap;
        return teardropShape;
    });
    const islands = [];
    let island = {
        r: [],
        l: []
    };
    for(let i = 0; i < points.length; i++){
        const current = points[i];
        // Calculate direction vectors
        // maybe we should do this after modifying the NEXT point and use the updated current
        let dx, dy;
        if (i === points.length - 1) {
            const prev = points[i - 1];
            dx = current[0] - prev[0];
            dy = current[1] - prev[1];
        } else {
            const next = points[i + 1];
            dx = next[0] - current[0];
            dy = next[1] - current[1];
        }
        const len = Math.sqrt(dx * dx + dy * dy);
        const nx = -dy / len;
        const ny = dx / len;
        const { top: top, bottom: bottom, total: total } = widths[i];
        if (river.w) river.w[i] = total;
        let gap = gaps[i];
        if (gap <= 0) {
            if (island.l.length > 0) {
                islands.push(island);
                island = {
                    r: [],
                    l: []
                };
            }
        }
        // Top channel -- centerline to terrain
        channels[0].l.push({
            gap: gap,
            x: current[0] - nx * gap * 0,
            y: current[1] - ny * gap * 0
        });
        channels[0].r.push({
            gap: 1,
            x: current[0] - nx * top - gap,
            y: current[1] - ny * top - gap
        });
        // Bottom channel -- terrain to centerline
        channels[1].l.push({
            gap: 1,
            x: current[0] + nx * bottom + gap,
            y: current[1] + ny * bottom + gap
        });
        channels[1].r.push({
            gap: gap,
            x: current[0] + nx * gap * 0,
            y: current[1] + ny * gap * 0
        });
        if (river.g) river.g[i] = gap / maxGap;
        if (gap > 0) {
            // Islands -- centerline to centerline
            island.l.push({
                gap: gap,
                x: current[0] - nx * gap,
                y: current[1] - ny * gap
            });
            island.r.push({
                gap: gap,
                x: current[0] + nx * gap,
                y: current[1] + ny * gap
            });
        }
    }
    channels[2] = islands;
    // Convert channels into closed paths
    return channels.map((channel, i)=>{
        if (i === 2) return channel.map((c)=>$300d32803541d4a4$var$flattenChannel(c));
        return $300d32803541d4a4$var$flattenChannel(channel);
    });
}
function $300d32803541d4a4$var$flattenChannel(channel) {
    const rightSideReversed = [
        ...channel.r
    ].reverse();
    const fullPath = [
        ...channel.l,
        ...rightSideReversed
    ];
    fullPath.push(fullPath[0]); // Close the path
    return fullPath;
}


function $820877bea407f5fe$export$6c4a311cc157c764(p1, p2) {
    const dx = p2[0] - p1[0];
    const dy = p2[1] - p1[1];
    return Math.hypot(dx, dy);
}
function $820877bea407f5fe$export$71255ea3f595147c(start, stop, num) {
    const step = (stop - start) / (num - 1);
    return Array.from({
        length: num
    }, (_, i)=>start + step * i);
}
function $820877bea407f5fe$export$7083016c6ddf412d(points, windowSize = 5) {
    const smoothed = new Array(points.length);
    for(let i = 0; i < points.length; i++){
        let sum = 0;
        let count = 0;
        for(let j = Math.max(0, i - windowSize); j < Math.min(points.length, i + windowSize + 1); j++){
            sum += points[j];
            count++;
        }
        smoothed[i] = sum / count;
    }
    return smoothed;
}
function $820877bea407f5fe$export$873a7ed854835bd7(points, windowSize = 5, passes = 2) {
    let result = points;
    for(let i = 0; i < passes; i++)result = $820877bea407f5fe$export$7083016c6ddf412d(result, windowSize);
    return result;
}
function $820877bea407f5fe$export$af0962e8c762b7ac(points) {
    let area = 0;
    for(let i = 0; i < points.length - 1; i++){
        area += points[i].x * points[i + 1].y;
        area -= points[i + 1].x * points[i].y;
    }
    return Math.abs(area) / 2;
}
function $820877bea407f5fe$export$8be39b708f3bcc6c(x1, y1, x2, y2, x3, y3, x4, y4) {
    const denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    if (denominator === 0) return null;
    const t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denominator;
    const u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denominator;
    if (t >= 0 && t <= 1 && u >= 0 && u <= 1) return {
        x: x1 + t * (x2 - x1),
        y: y1 + t * (y2 - y1)
    };
    return null;
}
function $820877bea407f5fe$export$9ab8d65b20cc4c12(points, cutoffs) {
    const minDistance = 30;
    const intersections = [];
    const intersectionSegments = [];
    const minSegmentDistance = 10;
    const totalPoints = points.length;
    const totalRiverPoints = (points.length - 1) / 2;
    // Spatial hash grid — O(n) average instead of O(n²)
    const cellSize = 40;
    let bMinX = Infinity, bMinY = Infinity;
    let bMaxX = -Infinity, bMaxY = -Infinity;
    for(let i = 0; i < totalPoints; i++){
        const px = points[i].x, py = points[i].y;
        if (px < bMinX) bMinX = px;
        if (py < bMinY) bMinY = py;
        if (px > bMaxX) bMaxX = px;
        if (py > bMaxY) bMaxY = py;
    }
    const cols = Math.floor((bMaxX - bMinX) / cellSize) + 2;
    const grid = new Map();
    for(let i = 0; i < totalPoints - 1; i++){
        const ax = points[i].x, ay = points[i].y;
        const bx = points[i + 1].x, by = points[i + 1].y;
        const minCx = Math.floor((Math.min(ax, bx) - bMinX) / cellSize);
        const maxCx = Math.floor((Math.max(ax, bx) - bMinX) / cellSize);
        const minCy = Math.floor((Math.min(ay, by) - bMinY) / cellSize);
        const maxCy = Math.floor((Math.max(ay, by) - bMinY) / cellSize);
        for(let cx = minCx; cx <= maxCx; cx++)for(let cy = minCy; cy <= maxCy; cy++){
            const key = cy * cols + cx;
            let bucket = grid.get(key);
            if (!bucket) {
                bucket = [];
                grid.set(key, bucket);
            }
            bucket.push(i);
        }
    }
    const visited = new Int32Array(totalPoints);
    let gen = 0;
    for(let i = 5; i < totalPoints - 1; i++){
        gen++;
        const ax = points[i].x, ay = points[i].y;
        const bx = points[i + 1].x, by = points[i + 1].y;
        const minCx = Math.floor((Math.min(ax, bx) - bMinX) / cellSize);
        const maxCx = Math.floor((Math.max(ax, bx) - bMinX) / cellSize);
        const minCy = Math.floor((Math.min(ay, by) - bMinY) / cellSize);
        const maxCy = Math.floor((Math.max(ay, by) - bMinY) / cellSize);
        for(let cx = minCx; cx <= maxCx; cx++)for(let cy = minCy; cy <= maxCy; cy++){
            const key = cy * cols + cx;
            const bucket = grid.get(key);
            if (!bucket) continue;
            for(let bi = 0; bi < bucket.length; bi++){
                const j = bucket[bi];
                if (j <= i + minSegmentDistance) continue;
                if (j > totalPoints - 5) continue;
                if (visited[j] === gen) continue;
                visited[j] = gen;
                const intersection = $820877bea407f5fe$export$8be39b708f3bcc6c(ax, ay, bx, by, points[j].x, points[j].y, points[j + 1].x, points[j + 1].y);
                if (intersection) {
                    const isUnique = intersections.every((existing)=>Math.hypot(existing.x - intersection.x, existing.y - intersection.y) > minDistance);
                    if (isUnique) {
                        let a = i;
                        if (a > totalRiverPoints) a = totalRiverPoints * 2 - a - 1;
                        let b = j;
                        if (b > totalRiverPoints) b = totalRiverPoints * 2 - b - 1;
                        let start = Math.min(a, b);
                        let end = Math.max(a, b);
                        intersections.push(intersection);
                        intersectionSegments.push({
                            start: start,
                            end: end,
                            startR: i,
                            endR: j,
                            type: "self"
                        });
                    }
                }
            }
        }
    }
    return {
        intersections: intersections,
        intersectionSegments: intersectionSegments
    };
}
function $820877bea407f5fe$export$87efdedd59138619(ctx, x, y, vectors, color = "red", scale = 20) {
    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    for(let i = 0; i < x.length; i++){
        ctx.beginPath();
        ctx.moveTo(x[i], y[i]);
        ctx.lineTo(x[i] + vectors[i][0] * scale, y[i] + vectors[i][1] * scale);
        ctx.stroke();
    }
}
function $820877bea407f5fe$export$ad7ddb6ad05f982e(ctx, x, y, vectors, color = "red", scale = 20) {
    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    for(let i = 0; i < x.length; i++){
        ctx.beginPath();
        // Start from half the vector length in one direction
        ctx.moveTo(x[i] - vectors[i][0] * scale * 0.5, y[i] - vectors[i][1] * scale * 0.5);
        // End at half the vector length in the other direction
        ctx.lineTo(x[i] + vectors[i][0] * scale * 0.5, y[i] + vectors[i][1] * scale * 0.5);
        ctx.stroke();
    }
}
function $820877bea407f5fe$export$58149486eefcda2e(vec, maxLength) {
    const length = Math.hypot(vec[0], vec[1]);
    if (length === 0) return vec; // Handle zero vector case
    if (length > maxLength) return [
        vec[0] / length * maxLength,
        vec[1] / length * maxLength
    ];
    return vec;
}
function $820877bea407f5fe$export$15356c20484a5e31(x, y, maxVectorLength) {
    const tangents = [];
    for(let i = 0; i < x.length; i++){
        let dx, dy;
        if (i === 0) {
            dx = x[1] - x[0];
            dy = y[1] - y[0];
        } else if (i === x.length - 1) {
            dx = x[i] - x[i - 1];
            dy = y[i] - y[i - 1];
        } else {
            dx = x[i + 1] - x[i - 1];
            dy = y[i + 1] - y[i - 1];
        }
        const unconstrained = [
            dx,
            dy
        ];
        tangents.push($820877bea407f5fe$export$58149486eefcda2e(unconstrained, maxVectorLength));
    }
    return tangents;
}
function $820877bea407f5fe$export$ae00d55f457928e(x, y) {
    const curvature = Array(x.length).fill(0);
    for(let i = 1; i < x.length - 1; i++){
        const dx1 = x[i] - x[i - 1];
        const dy1 = y[i] - y[i - 1];
        const dx2 = x[i + 1] - x[i];
        const dy2 = y[i + 1] - y[i];
        // angle between vectors
        const angle = Math.atan2(dx1 * dy2 - dy1 * dx2, dx1 * dx2 + dy1 * dy2);
        // normalize curvature to prevent extreme values
        curvature[i] = Math.tanh(angle); // This will keep values between -1 and 1
    }
    // Smooth out curvatures at extremities
    const L = x.length;
    const endPoints = Math.floor(L * 0.05);
    for(let i = 0; i < endPoints; i++){
        const t = i / endPoints;
        curvature[i] = curvature[i] * t;
    }
    for(let i = L - endPoints; i < L; i++){
        const t = (L - i) / endPoints;
        curvature[i] = curvature[i] * t;
    }
    // Apply smoothing to prevent sudden jumps
    return $820877bea407f5fe$export$873a7ed854835bd7(curvature, 3, 2);
}
function $820877bea407f5fe$export$13bc7c8899bb5b77(tangents, curvature, maxVectorLength) {
    return tangents.map((t, i)=>{
        const perpX = -t[1];
        const perpY = t[0];
        const scale = Math.abs(curvature[i]);
        const sign = Math.sign(curvature[i]);
        const unconstrained = [
            perpX * scale * sign,
            perpY * scale * sign
        ];
        // Apply stricter constraint and ensure W is positive
        return $820877bea407f5fe$export$58149486eefcda2e(unconstrained, maxVectorLength);
    });
}


const $450fab56b0cbf5ba$var$WORLD_WIDTH = 3000;
const $450fab56b0cbf5ba$var$WORLD_HEIGHT = 2000;
const $450fab56b0cbf5ba$var$SCALE = 0.8;
const $450fab56b0cbf5ba$var$POINTS = Math.round(1250 * $450fab56b0cbf5ba$var$SCALE);
let $450fab56b0cbf5ba$var$terrain;
function $450fab56b0cbf5ba$export$9ba598f95866daeb(t) {
    $450fab56b0cbf5ba$var$terrain = t;
    window.terrain = t;
}
function $450fab56b0cbf5ba$export$11e40c33b62a1ccd(W) {
    const len = $450fab56b0cbf5ba$var$WORLD_WIDTH;
    const x = (0, $820877bea407f5fe$export$71255ea3f595147c)(0, len, $450fab56b0cbf5ba$var$POINTS);
    const bends = 3;
    // Generate y coordinates with noise
    const y = new Array($450fab56b0cbf5ba$var$POINTS);
    for(let i = 0; i < $450fab56b0cbf5ba$var$POINTS; i++){
        const normalizedX = x[i] / len * bends * 2 * Math.PI;
        const sineComponent = W * Math.sin(normalizedX) + W * 0.5 * Math.sin(normalizedX * 0.5) + // Lower frequency for large curves
        W * 0.25 * Math.sin(normalizedX * 2.0) + // Higher frequency for detail
        W * 0.125 * Math.sin(normalizedX * 4.0); // Even higher for subtle variation
        y[i] = sineComponent;
    }
    // Smooth out just the ends (using percentage of points rather than fixed number)
    const endPoints = Math.floor($450fab56b0cbf5ba$var$POINTS * 0.05);
    for(let i = 0; i < endPoints; i++){
        const t = i / endPoints;
        y[i] = y[i] * t;
    }
    for(let i = $450fab56b0cbf5ba$var$POINTS - endPoints; i < $450fab56b0cbf5ba$var$POINTS; i++){
        const t = ($450fab56b0cbf5ba$var$POINTS - i) / endPoints;
        y[i] = y[i] * t;
    }
    const smoothedY = (0, $820877bea407f5fe$export$873a7ed854835bd7)(y, 3, 5);
    // Center the river in the world space
    const minX = Math.min(...x);
    const maxX = Math.max(...x);
    const minY = Math.min(...smoothedY);
    const maxY = Math.max(...smoothedY);
    // Calculate scaling factors to fit within world bounds while maintaining aspect ratio
    const scaleX = $450fab56b0cbf5ba$var$WORLD_WIDTH / (maxX - minX);
    const scaleY = $450fab56b0cbf5ba$var$WORLD_HEIGHT / (maxY - minY);
    // the percentage here basically controls the scale
    const scale = Math.min(scaleX, scaleY) * $450fab56b0cbf5ba$var$SCALE;
    // Center the river in world space
    const normalizedX = x.map((x)=>(x - minX) * scale + ($450fab56b0cbf5ba$var$WORLD_WIDTH - (maxX - minX) * scale) / 2);
    const normalizedY = smoothedY.map((y)=>(y - minY) * scale + ($450fab56b0cbf5ba$var$WORLD_HEIGHT - (maxY - minY) * scale) / 2);
    // Update terrain with river points
    $450fab56b0cbf5ba$var$terrain.setRiverPoints(normalizedX, normalizedY);
    return {
        x: normalizedX,
        y: normalizedY,
        g: Array($450fab56b0cbf5ba$var$POINTS).fill(0),
        w: Array($450fab56b0cbf5ba$var$POINTS).fill(0),
        hist: []
    };
}
function $450fab56b0cbf5ba$export$473fcb74eccce974(x, y, numPoints) {
    const arcLengths = [
        0
    ];
    let totalLength = 0;
    // Calculate cumulative arc lengths
    for(let i = 1; i < x.length; i++){
        const dx = x[i] - x[i - 1];
        const dy = y[i] - y[i - 1];
        const segmentLength = Math.sqrt(dx * dx + dy * dy);
        totalLength += segmentLength;
        arcLengths.push(totalLength);
    }
    const newX = [];
    const newY = [];
    // Resample points at equal arc length intervals
    for(let i = 0; i < numPoints; i++){
        const targetLength = i / (numPoints - 1) * totalLength;
        // Binary search for the segment containing this point
        let lo = 0;
        let hi = arcLengths.length - 2;
        while(lo < hi){
            const mid = lo + hi + 1 >> 1;
            if (arcLengths[mid] <= targetLength) lo = mid;
            else hi = mid - 1;
        }
        const segmentIndex = lo;
        // Interpolate between points
        const segmentLength = arcLengths[segmentIndex + 1] - arcLengths[segmentIndex];
        const t = segmentLength === 0 ? 0 : (targetLength - arcLengths[segmentIndex]) / segmentLength;
        newX.push(x[segmentIndex] + t * (x[segmentIndex + 1] - x[segmentIndex]));
        newY.push(y[segmentIndex] + t * (y[segmentIndex + 1] - y[segmentIndex]));
    }
    return {
        x: newX,
        y: newY
    };
}
function $450fab56b0cbf5ba$export$f34ba8b5435301be(river) {
    const { x: x, y: y } = river;
    const { x: newX, y: newY } = $450fab56b0cbf5ba$export$473fcb74eccce974(x, y, $450fab56b0cbf5ba$var$POINTS);
    river.x = newX;
    river.y = newY;
}
function $450fab56b0cbf5ba$export$279b7ad781fbe41(points, segmentInfo) {
    const { startR: startR, endR: endR } = segmentInfo;
    const loopPoints = points.slice(startR, endR);
    loopPoints.push(loopPoints[0]);
    return loopPoints;
}
function $450fab56b0cbf5ba$export$8f14948c2269a69b(river, segmentInfo, currentTime) {
    const { start: start, end: end } = segmentInfo;
    const x = [
        ...river.x.slice(0, start + 1),
        ...river.x.slice(end + 1)
    ];
    const y = [
        ...river.y.slice(0, start + 1),
        ...river.y.slice(end + 1)
    ];
    if (start > end) debugger;
    const n = 2;
    const cutoff = {
        x: river.x.slice(start + n, end),
        y: river.y.slice(start + n, end),
        time: currentTime,
        coords: "screen",
        type: "cutoff"
    };
    if (cutoff.x.length > 6) {
        river.hist.push(cutoff);
        if (river.hist.length > 500) river.hist.shift();
    }
    river.x = x;
    river.y = y;
    return river;
}
function $450fab56b0cbf5ba$export$cebb659625070b0f(x, y, w) {
    const sampleDistance = Math.round(w);
    let scale = 30;
    const SLOPE_THRESHOLD = 0.0001;
    const elevation = $450fab56b0cbf5ba$var$terrain.getElevation(x, y);
    const eRight = $450fab56b0cbf5ba$var$terrain.getElevation(x + sampleDistance, y);
    const eLeft = $450fab56b0cbf5ba$var$terrain.getElevation(x - sampleDistance, y);
    const eDown = $450fab56b0cbf5ba$var$terrain.getElevation(x, y + sampleDistance);
    const eUp = $450fab56b0cbf5ba$var$terrain.getElevation(x, y - sampleDistance);
    if (elevation >= 0.2 || eRight >= 0.2 || eLeft >= 0.2 || eDown >= 0.2 || eUp >= 0.2) scale = scale * 3;
    const gradientX = (eRight - eLeft) / (2 * sampleDistance) * scale;
    const gradientY = (eDown - eUp) / (2 * sampleDistance) * scale;
    if (Math.abs(gradientX) < SLOPE_THRESHOLD && Math.abs(gradientY) < SLOPE_THRESHOLD) return [
        0,
        0
    ];
    return [
        gradientX,
        gradientY
    ];
}



class $801989ee3d8d90d8$export$1b5a962e5964bd4c {
    constructor(canvas, bounds){
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
        this.updateBounds(bounds);
    }
    updateBounds(bounds) {
        this.bounds = bounds;
        this.scale = Math.min(this.canvas.width / bounds.width, this.canvas.height / bounds.height);
        this.startX = (this.canvas.width - bounds.width * this.scale) / 2 - bounds.minX * this.scale;
        this.startY = (this.canvas.height - bounds.height * this.scale) / 2 - bounds.minY * this.scale;
    }
    toScreen(x, y) {
        return {
            x: this.startX + x * this.scale,
            y: this.startY + y * this.scale
        };
    }
    toWorld(x, y) {
        return {
            x: (x - this.startX) / this.scale,
            y: (y - this.startY) / this.scale
        };
    }
    transformPoints(points) {
        return points.map((p)=>this.toScreen(p.x, p.y));
    }
    vectorToScreen(vx, vy) {
        const scale = Math.min(this.canvas.width / this.bounds.width, this.canvas.height / this.bounds.height);
        return {
            x: vx * scale,
            y: vy * scale
        };
    }
}


/*
 * A fast javascript implementation of simplex noise by Jonas Wagner

Based on a speed-improved simplex noise algorithm for 2D, 3D and 4D in Java.
Which is based on example code by Stefan Gustavson (stegu@itn.liu.se).
With Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
Better rank ordering method by Stefan Gustavson in 2012.

 Copyright (c) 2024 Jonas Wagner

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */ // these __PURE__ comments help uglifyjs with dead code removal
//
const $a07fab4af3cbb7ce$var$SQRT3 = /*#__PURE__*/ Math.sqrt(3.0);
const $a07fab4af3cbb7ce$var$SQRT5 = /*#__PURE__*/ Math.sqrt(5.0);
const $a07fab4af3cbb7ce$var$F2 = 0.5 * ($a07fab4af3cbb7ce$var$SQRT3 - 1.0);
const $a07fab4af3cbb7ce$var$G2 = (3.0 - $a07fab4af3cbb7ce$var$SQRT3) / 6.0;
const $a07fab4af3cbb7ce$var$F3 = 1.0 / 3.0;
const $a07fab4af3cbb7ce$var$G3 = 1.0 / 6.0;
const $a07fab4af3cbb7ce$var$F4 = ($a07fab4af3cbb7ce$var$SQRT5 - 1.0) / 4.0;
const $a07fab4af3cbb7ce$var$G4 = (5.0 - $a07fab4af3cbb7ce$var$SQRT5) / 20.0;
// I'm really not sure why this | 0 (basically a coercion to int)
// is making this faster but I get ~5 million ops/sec more on the
// benchmarks across the board or a ~10% speedup.
const $a07fab4af3cbb7ce$var$fastFloor = (x)=>Math.floor(x) | 0;
const $a07fab4af3cbb7ce$var$grad2 = /*#__PURE__*/ new Float64Array([
    1,
    1,
    -1,
    1,
    1,
    -1,
    -1,
    -1,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1,
    0,
    0,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1
]);
// double seems to be faster than single or int's
// probably because most operations are in double precision
const $a07fab4af3cbb7ce$var$grad3 = /*#__PURE__*/ new Float64Array([
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1,
    0,
    1,
    0,
    1,
    -1,
    0,
    1,
    1,
    0,
    -1,
    -1,
    0,
    -1,
    0,
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1
]);
// double is a bit quicker here as well
const $a07fab4af3cbb7ce$var$grad4 = /*#__PURE__*/ new Float64Array([
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    -1,
    1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    0
]);
function $a07fab4af3cbb7ce$export$9de79e9646a874e5(random = Math.random) {
    const perm = $a07fab4af3cbb7ce$export$98cd52c6119fe283(random);
    // precalculating this yields a little ~3% performance improvement.
    const permGrad2x = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad2[v % 12 * 2]);
    const permGrad2y = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad2[v % 12 * 2 + 1]);
    return function noise2D(x, y) {
        // if(!isFinite(x) || !isFinite(y)) return 0;
        let n0 = 0; // Noise contributions from the three corners
        let n1 = 0;
        let n2 = 0;
        // Skew the input space to determine which simplex cell we're in
        const s = (x + y) * $a07fab4af3cbb7ce$var$F2; // Hairy factor for 2D
        const i = $a07fab4af3cbb7ce$var$fastFloor(x + s);
        const j = $a07fab4af3cbb7ce$var$fastFloor(y + s);
        const t = (i + j) * $a07fab4af3cbb7ce$var$G2;
        const X0 = i - t; // Unskew the cell origin back to (x,y) space
        const Y0 = j - t;
        const x0 = x - X0; // The x,y distances from the cell origin
        const y0 = y - Y0;
        // For the 2D case, the simplex shape is an equilateral triangle.
        // Determine which simplex we are in.
        let i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
        if (x0 > y0) {
            i1 = 1;
            j1 = 0;
        } else {
            i1 = 0;
            j1 = 1;
        } // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
        // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
        // c = (3-sqrt(3))/6
        const x1 = x0 - i1 + $a07fab4af3cbb7ce$var$G2; // Offsets for middle corner in (x,y) unskewed coords
        const y1 = y0 - j1 + $a07fab4af3cbb7ce$var$G2;
        const x2 = x0 - 1.0 + 2.0 * $a07fab4af3cbb7ce$var$G2; // Offsets for last corner in (x,y) unskewed coords
        const y2 = y0 - 1.0 + 2.0 * $a07fab4af3cbb7ce$var$G2;
        // Work out the hashed gradient indices of the three simplex corners
        const ii = i & 255;
        const jj = j & 255;
        // Calculate the contribution from the three corners
        let t0 = 0.5 - x0 * x0 - y0 * y0;
        if (t0 >= 0) {
            const gi0 = ii + perm[jj];
            const g0x = permGrad2x[gi0];
            const g0y = permGrad2y[gi0];
            t0 *= t0;
            // n0 = t0 * t0 * (grad2[gi0] * x0 + grad2[gi0 + 1] * y0); // (x,y) of grad3 used for 2D gradient
            n0 = t0 * t0 * (g0x * x0 + g0y * y0);
        }
        let t1 = 0.5 - x1 * x1 - y1 * y1;
        if (t1 >= 0) {
            const gi1 = ii + i1 + perm[jj + j1];
            const g1x = permGrad2x[gi1];
            const g1y = permGrad2y[gi1];
            t1 *= t1;
            // n1 = t1 * t1 * (grad2[gi1] * x1 + grad2[gi1 + 1] * y1);
            n1 = t1 * t1 * (g1x * x1 + g1y * y1);
        }
        let t2 = 0.5 - x2 * x2 - y2 * y2;
        if (t2 >= 0) {
            const gi2 = ii + 1 + perm[jj + 1];
            const g2x = permGrad2x[gi2];
            const g2y = permGrad2y[gi2];
            t2 *= t2;
            // n2 = t2 * t2 * (grad2[gi2] * x2 + grad2[gi2 + 1] * y2);
            n2 = t2 * t2 * (g2x * x2 + g2y * y2);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 70.0 * (n0 + n1 + n2);
    };
}
function $a07fab4af3cbb7ce$export$80cd39cae172f7fa(random = Math.random) {
    const perm = $a07fab4af3cbb7ce$export$98cd52c6119fe283(random);
    // precalculating these seems to yield a speedup of over 15%
    const permGrad3x = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad3[v % 12 * 3]);
    const permGrad3y = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad3[v % 12 * 3 + 1]);
    const permGrad3z = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad3[v % 12 * 3 + 2]);
    return function noise3D(x, y, z) {
        let n0, n1, n2, n3; // Noise contributions from the four corners
        // Skew the input space to determine which simplex cell we're in
        const s = (x + y + z) * $a07fab4af3cbb7ce$var$F3; // Very nice and simple skew factor for 3D
        const i = $a07fab4af3cbb7ce$var$fastFloor(x + s);
        const j = $a07fab4af3cbb7ce$var$fastFloor(y + s);
        const k = $a07fab4af3cbb7ce$var$fastFloor(z + s);
        const t = (i + j + k) * $a07fab4af3cbb7ce$var$G3;
        const X0 = i - t; // Unskew the cell origin back to (x,y,z) space
        const Y0 = j - t;
        const Z0 = k - t;
        const x0 = x - X0; // The x,y,z distances from the cell origin
        const y0 = y - Y0;
        const z0 = z - Z0;
        // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
        // Determine which simplex we are in.
        let i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
        let i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
        if (x0 >= y0) {
            if (y0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } else if (x0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } // Z X Y order
        } else {
            if (y0 < z0) {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else if (x0 < z0) {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } // Y X Z order
        }
        // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
        // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
        // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
        // c = 1/6.
        const x1 = x0 - i1 + $a07fab4af3cbb7ce$var$G3; // Offsets for second corner in (x,y,z) coords
        const y1 = y0 - j1 + $a07fab4af3cbb7ce$var$G3;
        const z1 = z0 - k1 + $a07fab4af3cbb7ce$var$G3;
        const x2 = x0 - i2 + 2.0 * $a07fab4af3cbb7ce$var$G3; // Offsets for third corner in (x,y,z) coords
        const y2 = y0 - j2 + 2.0 * $a07fab4af3cbb7ce$var$G3;
        const z2 = z0 - k2 + 2.0 * $a07fab4af3cbb7ce$var$G3;
        const x3 = x0 - 1.0 + 3.0 * $a07fab4af3cbb7ce$var$G3; // Offsets for last corner in (x,y,z) coords
        const y3 = y0 - 1.0 + 3.0 * $a07fab4af3cbb7ce$var$G3;
        const z3 = z0 - 1.0 + 3.0 * $a07fab4af3cbb7ce$var$G3;
        // Work out the hashed gradient indices of the four simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const kk = k & 255;
        // Calculate the contribution from the four corners
        let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
        if (t0 < 0) n0 = 0.0;
        else {
            const gi0 = ii + perm[jj + perm[kk]];
            t0 *= t0;
            n0 = t0 * t0 * (permGrad3x[gi0] * x0 + permGrad3y[gi0] * y0 + permGrad3z[gi0] * z0);
        }
        let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
        if (t1 < 0) n1 = 0.0;
        else {
            const gi1 = ii + i1 + perm[jj + j1 + perm[kk + k1]];
            t1 *= t1;
            n1 = t1 * t1 * (permGrad3x[gi1] * x1 + permGrad3y[gi1] * y1 + permGrad3z[gi1] * z1);
        }
        let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
        if (t2 < 0) n2 = 0.0;
        else {
            const gi2 = ii + i2 + perm[jj + j2 + perm[kk + k2]];
            t2 *= t2;
            n2 = t2 * t2 * (permGrad3x[gi2] * x2 + permGrad3y[gi2] * y2 + permGrad3z[gi2] * z2);
        }
        let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
        if (t3 < 0) n3 = 0.0;
        else {
            const gi3 = ii + 1 + perm[jj + 1 + perm[kk + 1]];
            t3 *= t3;
            n3 = t3 * t3 * (permGrad3x[gi3] * x3 + permGrad3y[gi3] * y3 + permGrad3z[gi3] * z3);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to stay just inside [-1,1]
        return 32.0 * (n0 + n1 + n2 + n3);
    };
}
function $a07fab4af3cbb7ce$export$8ec263ee3d525d98(random = Math.random) {
    const perm = $a07fab4af3cbb7ce$export$98cd52c6119fe283(random);
    // precalculating these leads to a ~10% speedup
    const permGrad4x = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad4[v % 32 * 4]);
    const permGrad4y = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad4[v % 32 * 4 + 1]);
    const permGrad4z = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad4[v % 32 * 4 + 2]);
    const permGrad4w = new Float64Array(perm).map((v)=>$a07fab4af3cbb7ce$var$grad4[v % 32 * 4 + 3]);
    return function noise4D(x, y, z, w) {
        let n0, n1, n2, n3, n4; // Noise contributions from the five corners
        // Skew the (x,y,z,w) space to determine which cell of 24 simplices we're in
        const s = (x + y + z + w) * $a07fab4af3cbb7ce$var$F4; // Factor for 4D skewing
        const i = $a07fab4af3cbb7ce$var$fastFloor(x + s);
        const j = $a07fab4af3cbb7ce$var$fastFloor(y + s);
        const k = $a07fab4af3cbb7ce$var$fastFloor(z + s);
        const l = $a07fab4af3cbb7ce$var$fastFloor(w + s);
        const t = (i + j + k + l) * $a07fab4af3cbb7ce$var$G4; // Factor for 4D unskewing
        const X0 = i - t; // Unskew the cell origin back to (x,y,z,w) space
        const Y0 = j - t;
        const Z0 = k - t;
        const W0 = l - t;
        const x0 = x - X0; // The x,y,z,w distances from the cell origin
        const y0 = y - Y0;
        const z0 = z - Z0;
        const w0 = w - W0;
        // For the 4D case, the simplex is a 4D shape I won't even try to describe.
        // To find out which of the 24 possible simplices we're in, we need to
        // determine the magnitude ordering of x0, y0, z0 and w0.
        // Six pair-wise comparisons are performed between each possible pair
        // of the four coordinates, and the results are used to rank the numbers.
        let rankx = 0;
        let ranky = 0;
        let rankz = 0;
        let rankw = 0;
        if (x0 > y0) rankx++;
        else ranky++;
        if (x0 > z0) rankx++;
        else rankz++;
        if (x0 > w0) rankx++;
        else rankw++;
        if (y0 > z0) ranky++;
        else rankz++;
        if (y0 > w0) ranky++;
        else rankw++;
        if (z0 > w0) rankz++;
        else rankw++;
        // simplex[c] is a 4-vector with the numbers 0, 1, 2 and 3 in some order.
        // Many values of c will never occur, since e.g. x>y>z>w makes x<z, y<w and x<w
        // impossible. Only the 24 indices which have non-zero entries make any sense.
        // We use a thresholding to set the coordinates in turn from the largest magnitude.
        // Rank 3 denotes the largest coordinate.
        // Rank 2 denotes the second largest coordinate.
        // Rank 1 denotes the second smallest coordinate.
        // The integer offsets for the second simplex corner
        const i1 = rankx >= 3 ? 1 : 0;
        const j1 = ranky >= 3 ? 1 : 0;
        const k1 = rankz >= 3 ? 1 : 0;
        const l1 = rankw >= 3 ? 1 : 0;
        // The integer offsets for the third simplex corner
        const i2 = rankx >= 2 ? 1 : 0;
        const j2 = ranky >= 2 ? 1 : 0;
        const k2 = rankz >= 2 ? 1 : 0;
        const l2 = rankw >= 2 ? 1 : 0;
        // The integer offsets for the fourth simplex corner
        const i3 = rankx >= 1 ? 1 : 0;
        const j3 = ranky >= 1 ? 1 : 0;
        const k3 = rankz >= 1 ? 1 : 0;
        const l3 = rankw >= 1 ? 1 : 0;
        // The fifth corner has all coordinate offsets = 1, so no need to compute that.
        const x1 = x0 - i1 + $a07fab4af3cbb7ce$var$G4; // Offsets for second corner in (x,y,z,w) coords
        const y1 = y0 - j1 + $a07fab4af3cbb7ce$var$G4;
        const z1 = z0 - k1 + $a07fab4af3cbb7ce$var$G4;
        const w1 = w0 - l1 + $a07fab4af3cbb7ce$var$G4;
        const x2 = x0 - i2 + 2.0 * $a07fab4af3cbb7ce$var$G4; // Offsets for third corner in (x,y,z,w) coords
        const y2 = y0 - j2 + 2.0 * $a07fab4af3cbb7ce$var$G4;
        const z2 = z0 - k2 + 2.0 * $a07fab4af3cbb7ce$var$G4;
        const w2 = w0 - l2 + 2.0 * $a07fab4af3cbb7ce$var$G4;
        const x3 = x0 - i3 + 3.0 * $a07fab4af3cbb7ce$var$G4; // Offsets for fourth corner in (x,y,z,w) coords
        const y3 = y0 - j3 + 3.0 * $a07fab4af3cbb7ce$var$G4;
        const z3 = z0 - k3 + 3.0 * $a07fab4af3cbb7ce$var$G4;
        const w3 = w0 - l3 + 3.0 * $a07fab4af3cbb7ce$var$G4;
        const x4 = x0 - 1.0 + 4.0 * $a07fab4af3cbb7ce$var$G4; // Offsets for last corner in (x,y,z,w) coords
        const y4 = y0 - 1.0 + 4.0 * $a07fab4af3cbb7ce$var$G4;
        const z4 = z0 - 1.0 + 4.0 * $a07fab4af3cbb7ce$var$G4;
        const w4 = w0 - 1.0 + 4.0 * $a07fab4af3cbb7ce$var$G4;
        // Work out the hashed gradient indices of the five simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const kk = k & 255;
        const ll = l & 255;
        // Calculate the contribution from the five corners
        let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0 - w0 * w0;
        if (t0 < 0) n0 = 0.0;
        else {
            const gi0 = ii + perm[jj + perm[kk + perm[ll]]];
            t0 *= t0;
            n0 = t0 * t0 * (permGrad4x[gi0] * x0 + permGrad4y[gi0] * y0 + permGrad4z[gi0] * z0 + permGrad4w[gi0] * w0);
        }
        let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1 - w1 * w1;
        if (t1 < 0) n1 = 0.0;
        else {
            const gi1 = ii + i1 + perm[jj + j1 + perm[kk + k1 + perm[ll + l1]]];
            t1 *= t1;
            n1 = t1 * t1 * (permGrad4x[gi1] * x1 + permGrad4y[gi1] * y1 + permGrad4z[gi1] * z1 + permGrad4w[gi1] * w1);
        }
        let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2 - w2 * w2;
        if (t2 < 0) n2 = 0.0;
        else {
            const gi2 = ii + i2 + perm[jj + j2 + perm[kk + k2 + perm[ll + l2]]];
            t2 *= t2;
            n2 = t2 * t2 * (permGrad4x[gi2] * x2 + permGrad4y[gi2] * y2 + permGrad4z[gi2] * z2 + permGrad4w[gi2] * w2);
        }
        let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3 - w3 * w3;
        if (t3 < 0) n3 = 0.0;
        else {
            const gi3 = ii + i3 + perm[jj + j3 + perm[kk + k3 + perm[ll + l3]]];
            t3 *= t3;
            n3 = t3 * t3 * (permGrad4x[gi3] * x3 + permGrad4y[gi3] * y3 + permGrad4z[gi3] * z3 + permGrad4w[gi3] * w3);
        }
        let t4 = 0.6 - x4 * x4 - y4 * y4 - z4 * z4 - w4 * w4;
        if (t4 < 0) n4 = 0.0;
        else {
            const gi4 = ii + 1 + perm[jj + 1 + perm[kk + 1 + perm[ll + 1]]];
            t4 *= t4;
            n4 = t4 * t4 * (permGrad4x[gi4] * x4 + permGrad4y[gi4] * y4 + permGrad4z[gi4] * z4 + permGrad4w[gi4] * w4);
        }
        // Sum up and scale the result to cover the range [-1,1]
        return 27.0 * (n0 + n1 + n2 + n3 + n4);
    };
}
function $a07fab4af3cbb7ce$export$98cd52c6119fe283(random) {
    const tableSize = 512;
    const p = new Uint8Array(tableSize);
    for(let i = 0; i < tableSize / 2; i++)p[i] = i;
    for(let i = 0; i < tableSize / 2 - 1; i++){
        const r = i + ~~(random() * (256 - i));
        const aux = p[i];
        p[i] = p[r];
        p[r] = aux;
    }
    for(let i = 256; i < tableSize; i++)p[i] = p[i - 256];
    return p;
}


const $806cd3fd01d2a855$var$elevations = [];
const $806cd3fd01d2a855$var$aggradation = [];
const $806cd3fd01d2a855$var$erosion = [];
window.elevations = $806cd3fd01d2a855$var$elevations;
window.aggradation = $806cd3fd01d2a855$var$aggradation;
window.erosion = $806cd3fd01d2a855$var$erosion;
class $806cd3fd01d2a855$var$TerrainGenerator {
    constructor(prng){
        this.prng = prng;
        this.noise2D = (0, $a07fab4af3cbb7ce$export$9de79e9646a874e5)(prng);
        this.riverPoints = null;
        this.frequency = 1 / 400;
        // low elevation terraces
        this.stepWidth = 0.4;
        this.numSteps = 10;
    }
    p(n) {
        return 1 + (this.prng() - 0.5) / n;
    }
    width(x, y) {
        // [3, 10]
        return Math.max(3, 2 + this.noise2D(x / 200, y / 200) * 8);
    }
    setRiverPoints(x, y) {
        this.riverPoints = {
            x: x,
            y: y
        };
        this.minX = Math.min(...x);
        this.maxX = Math.max(...x);
    }
    // Get the minimum distance from a point to the river
    getRiverDistance(x, y) {
        if (!this.riverPoints) return Infinity;
        let minDist = Infinity;
        for(let i = 0; i < this.riverPoints.x.length; i++){
            const dx = x - this.riverPoints.x[i];
            const dy = y - this.riverPoints.y[i];
            const dist = Math.sqrt(dx * dx + dy * dy);
            minDist = Math.min(minDist, dist);
        }
        return minDist;
    }
    terrace(x, y) {
        const progression = 1 - (x - this.minX) / (this.maxX - this.minX);
        const combined = progression + this.noise2D(-x * this.frequency * 1.3, -y * this.frequency * 1.3) * this.stepWidth;
        const value = Math.floor(combined * this.numSteps) / this.numSteps;
        // 1/5 because we apply this when elevation < 0.2 (=1/5)
        return Math.max(0, Math.min(1, value)) / 5;
    }
    // Get elevation at a point
    getElevation(x, y) {
        const a = Math.floor(x);
        const b = Math.floor(y);
        if ($806cd3fd01d2a855$var$elevations[a] && typeof $806cd3fd01d2a855$var$elevations[a][b] === "number") return $806cd3fd01d2a855$var$elevations[a][b];
        // Generate base terrain using multiple octaves of noise
        let elevation = 0;
        let amplitude = 1.0;
        let freq = this.frequency;
        for(let i = 0; i < 4; i++){
            elevation += amplitude * this.noise2D(x * freq, y * freq);
            amplitude *= 0.5;
            freq *= 2;
        }
        // Scale elevation to 0-1 range
        elevation = (elevation + 1) * 0.5;
        const dist = this.getRiverDistance(x, y);
        const D = 400;
        const sqD = Math.sqrt(D);
        if (dist < D) elevation = Math.max(0, elevation - (1 - Math.sqrt(dist) / sqD));
        if (elevation < 0.2) elevation = this.terrace(x, y) - (1 - Math.sqrt(dist) / sqD) / 10;
        if (!Array.isArray($806cd3fd01d2a855$var$elevations[a])) {
            $806cd3fd01d2a855$var$elevations[a] = [];
            $806cd3fd01d2a855$var$aggradation[a] = [];
            $806cd3fd01d2a855$var$erosion[a] = [];
        }
        $806cd3fd01d2a855$var$elevations[a][b] = elevation;
        $806cd3fd01d2a855$var$erosion[a][b] = 0;
        $806cd3fd01d2a855$var$aggradation[a][b] = 0;
        return elevation;
    }
    deposit(x, y) {
        const a = Math.floor(x);
        const b = Math.floor(y);
        if (!$806cd3fd01d2a855$var$aggradation[a]) $806cd3fd01d2a855$var$aggradation[a] = Array(b).fill(0);
        if ($806cd3fd01d2a855$var$aggradation[a] && typeof $806cd3fd01d2a855$var$aggradation[a][b] === "number") {
            $806cd3fd01d2a855$var$aggradation[a][b]++;
            // if (elevations[a] && typeof elevations[a][b] === "number") {
            //   elevations[a][b] += 0.01;
            // }
            if (this.getErosion(a, b) > 0) $806cd3fd01d2a855$var$erosion[a][b]--;
        }
    }
    erode(x, y, factor = 1) {
        const a = Math.floor(x);
        const b = Math.floor(y);
        if ($806cd3fd01d2a855$var$erosion[a] && typeof $806cd3fd01d2a855$var$erosion[a][b] === "number") {
            $806cd3fd01d2a855$var$erosion[a][b] += factor / 10;
            if ($806cd3fd01d2a855$var$elevations[a] && typeof $806cd3fd01d2a855$var$elevations[a][b] === "number" && $806cd3fd01d2a855$var$elevations[a][b] > -3) $806cd3fd01d2a855$var$elevations[a][b] -= $806cd3fd01d2a855$var$erosion[a][b] / 10000;
        // if (this.getAggradation(a, b) > 0) aggradation[a][b]--;
        }
    }
    getErosion(x, y) {
        const a = Math.floor(x);
        const b = Math.floor(y);
        if ($806cd3fd01d2a855$var$erosion[a] && $806cd3fd01d2a855$var$erosion[a][b]) return $806cd3fd01d2a855$var$erosion[a][b];
        return 0;
    }
    getAggradation(x, y, factor = 1) {
        const a = Math.floor(x);
        const b = Math.floor(y);
        if ($806cd3fd01d2a855$var$aggradation[a] && $806cd3fd01d2a855$var$aggradation[a][b]) return $806cd3fd01d2a855$var$aggradation[a][b];
        if ($806cd3fd01d2a855$var$elevations[a] && typeof $806cd3fd01d2a855$var$elevations[a][b] === "number") $806cd3fd01d2a855$var$elevations[a][b] += factor / 1000;
        return 0;
    }
}
var $806cd3fd01d2a855$export$2e2bcd8739ae039 = $806cd3fd01d2a855$var$TerrainGenerator;


var $16ff360444b94c7d$exports = {};
(function(root, factory) {
    $16ff360444b94c7d$exports = factory();
})($16ff360444b94c7d$exports, function() {
    'use strict';
    // From http://baagoe.com/en/RandomMusings/javascript/
    // importState to sync generator states
    Alea.importState = function(i) {
        var random = new Alea();
        random.importState(i);
        return random;
    };
    return Alea;
    function Alea() {
        return function(args) {
            // Johannes Baagøe <baagoe@baagoe.com>, 2010
            var s0 = 0;
            var s1 = 0;
            var s2 = 0;
            var c = 1;
            if (args.length == 0) args = [
                +new Date
            ];
            var mash = Mash();
            s0 = mash(' ');
            s1 = mash(' ');
            s2 = mash(' ');
            for(var i = 0; i < args.length; i++){
                s0 -= mash(args[i]);
                if (s0 < 0) s0 += 1;
                s1 -= mash(args[i]);
                if (s1 < 0) s1 += 1;
                s2 -= mash(args[i]);
                if (s2 < 0) s2 += 1;
            }
            mash = null;
            var random = function() {
                var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
            };
            random.next = random;
            random.uint32 = function() {
                return random() * 0x100000000; // 2^32
            };
            random.fract53 = function() {
                return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
            };
            random.version = 'Alea 0.9';
            random.args = args;
            // my own additions to sync state between two generators
            random.exportState = function() {
                return [
                    s0,
                    s1,
                    s2,
                    c
                ];
            };
            random.importState = function(i) {
                s0 = +i[0] || 0;
                s1 = +i[1] || 0;
                s2 = +i[2] || 0;
                c = +i[3] || 0;
            };
            return random;
        }(Array.prototype.slice.call(arguments));
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = data.toString();
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        mash.version = 'Mash 0.9';
        return mash;
    }
});


const $35da740d59af89ba$var$initTime = Date.now();
let $35da740d59af89ba$var$endInitTime;
const $35da740d59af89ba$var$canvas = document.getElementById("canvas");
const $35da740d59af89ba$var$ctx = $35da740d59af89ba$var$canvas.getContext("2d");
let $35da740d59af89ba$var$river;
let $35da740d59af89ba$var$bounds;
let $35da740d59af89ba$var$slopeVectors = [];
const $35da740d59af89ba$var$SEED = Math.round(Math.random() * 1e6);
// const SEED = 762;
console.log("seed", $35da740d59af89ba$var$SEED);
const $35da740d59af89ba$var$PRINT_ANIMATION_FRAME = false;
const $35da740d59af89ba$var$DRAW_CHANNELS = true;
const $35da740d59af89ba$var$DRAW_CONTOURS = true;
const $35da740d59af89ba$var$DRAW_CUTOFFS = true;
const $35da740d59af89ba$var$DRAW_EROSION = false;
const $35da740d59af89ba$var$DRAW_HIST = true;
const $35da740d59af89ba$var$DRAW_INTERSECTIONS = false;
const $35da740d59af89ba$var$DRAW_NOISE = false;
const $35da740d59af89ba$var$DRAW_RIVER = true;
const $35da740d59af89ba$var$DRAW_SLOPE = false;
const $35da740d59af89ba$var$DRAW_VECTORS = false;
const $35da740d59af89ba$var$SHORTEN_CUTOFFS = false;
const $35da740d59af89ba$var$SKIP_N_FRAMES = 0;
const $35da740d59af89ba$var$SHOW_FPS = false;
const $35da740d59af89ba$var$W = 30;
const $35da740d59af89ba$var$TANGENT_INFLUENCE = 0.3;
const $35da740d59af89ba$var$BITANGENT_INFLUENCE = 1;
const $35da740d59af89ba$var$SLOPE_INFLUENCE = 3;
const $35da740d59af89ba$var$MAX_VECTOR_LENGTH = 2;
const $35da740d59af89ba$var$SAVE_HIST_EVERY = 20;
// window.stopAtAnimationFrame = 100;
const $35da740d59af89ba$var$COLORS = {
    BACKGROUND: [
        247,
        251,
        232
    ],
    ACTIVE_CHANNEL: [
        110,
        157,
        223
    ],
    INACTIVE_CHANNEL: [
        245,
        222,
        179
    ],
    FADE_COLOR: [
        255,
        255,
        255
    ],
    OUTLINE: [
        14,
        68,
        114
    ],
    BLACK: [
        0,
        0,
        0
    ],
    WHITE: [
        255,
        255,
        255
    ],
    CONTOUR: [
        0,
        0,
        0,
        0.1
    ]
};
function $35da740d59af89ba$var$rgb(c) {
    return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
}
const $35da740d59af89ba$var$CONTOUR_INTERVAL = 0.03; // Interval between contour lines (0-1)
const $35da740d59af89ba$var$prng = (0, (/*@__PURE__*/$parcel$interopDefault($16ff360444b94c7d$exports)))($35da740d59af89ba$var$SEED);
let $35da740d59af89ba$var$cachedNoiseImage = null;
let $35da740d59af89ba$var$cachedContours = null;
let $35da740d59af89ba$var$lastNoiseWidth = 0;
let $35da740d59af89ba$var$lastNoiseHeight = 0;
let $35da740d59af89ba$var$worldCanvas;
let $35da740d59af89ba$var$terrain;
function $35da740d59af89ba$var$computeBounds(x, y) {
    const minX = Math.min(...x);
    const maxX = Math.max(...x);
    return {
        minX: minX,
        maxX: maxX,
        minY: Math.min(...y),
        maxY: Math.max(...y),
        width: maxX - minX,
        height: Math.max(...y) - Math.min(...y)
    };
}
function $35da740d59af89ba$var$blendVectors(river, i, tangent, bitangent) {
    const x = river.x[i];
    const y = river.y[i];
    const g = river.g[i];
    const w = river.w[i];
    // Calculate normalized position (0 to 1) relative to screen width
    const screenX = (x - $35da740d59af89ba$var$bounds.minX) / $35da740d59af89ba$var$bounds.width;
    const fadePaddingPercent = 0.08;
    // Calculate edge influence factor (0 near edges, 1 in center)
    let edgeFactor = Math.min(1, Math.min(screenX / fadePaddingPercent, 1), Math.min((1 - screenX + 30) / fadePaddingPercent, 1));
    if (screenX >= 1) edgeFactor = 0;
    const slope = (0, $450fab56b0cbf5ba$export$cebb659625070b0f)(x, y, w);
    if ($35da740d59af89ba$var$DRAW_SLOPE) $35da740d59af89ba$var$slopeVectors.push({
        slope: [
            slope[0] * $35da740d59af89ba$var$SLOPE_INFLUENCE,
            slope[1] * $35da740d59af89ba$var$SLOPE_INFLUENCE
        ],
        x: x,
        y: y
    });
    const G_FACTOR = 1 - g;
    const tx = tangent[0] * $35da740d59af89ba$var$TANGENT_INFLUENCE * edgeFactor * $35da740d59af89ba$var$terrain.p(10) * G_FACTOR + bitangent[0] * $35da740d59af89ba$var$BITANGENT_INFLUENCE * edgeFactor * $35da740d59af89ba$var$terrain.p(10) * G_FACTOR + slope[0] * $35da740d59af89ba$var$SLOPE_INFLUENCE * edgeFactor;
    const ty = tangent[1] * $35da740d59af89ba$var$TANGENT_INFLUENCE * edgeFactor * $35da740d59af89ba$var$terrain.p(10) * G_FACTOR + bitangent[1] * $35da740d59af89ba$var$BITANGENT_INFLUENCE * edgeFactor * $35da740d59af89ba$var$terrain.p(10) * G_FACTOR + slope[1] * $35da740d59af89ba$var$SLOPE_INFLUENCE * edgeFactor;
    const unconstrained = [
        tx,
        ty
    ];
    return (0, $820877bea407f5fe$export$58149486eefcda2e)(unconstrained, $35da740d59af89ba$var$MAX_VECTOR_LENGTH);
}
function $35da740d59af89ba$var$generateRiver() {
    // Initialize terrain before river
    $35da740d59af89ba$var$terrain = new (0, $806cd3fd01d2a855$export$2e2bcd8739ae039)($35da740d59af89ba$var$prng);
    (0, $450fab56b0cbf5ba$export$9ba598f95866daeb)($35da740d59af89ba$var$terrain);
    $35da740d59af89ba$var$river = (0, $450fab56b0cbf5ba$export$11e40c33b62a1ccd)($35da740d59af89ba$var$W);
    $35da740d59af89ba$var$bounds = $35da740d59af89ba$var$computeBounds($35da740d59af89ba$var$river.x, $35da740d59af89ba$var$river.y);
    window.river = $35da740d59af89ba$var$river;
    window.bounds = $35da740d59af89ba$var$bounds;
    $35da740d59af89ba$var$worldCanvas = new (0, $801989ee3d8d90d8$export$1b5a962e5964bd4c)($35da740d59af89ba$var$canvas, $35da740d59af89ba$var$bounds);
    // Store initial endpoints
    $35da740d59af89ba$var$river.startPoint = {
        x: $35da740d59af89ba$var$river.x[0],
        y: $35da740d59af89ba$var$river.y[0]
    };
    $35da740d59af89ba$var$river.endPoint = {
        x: $35da740d59af89ba$var$river.x[$35da740d59af89ba$var$river.x.length - 1],
        y: $35da740d59af89ba$var$river.y[$35da740d59af89ba$var$river.y.length - 1]
    };
}
function $35da740d59af89ba$var$updateRiver(blend = true) {
    if (blend) {
        const tangents = (0, $820877bea407f5fe$export$15356c20484a5e31)($35da740d59af89ba$var$river.x, $35da740d59af89ba$var$river.y, $35da740d59af89ba$var$MAX_VECTOR_LENGTH);
        $35da740d59af89ba$var$river.curvature = (0, $820877bea407f5fe$export$ae00d55f457928e)($35da740d59af89ba$var$river.x, $35da740d59af89ba$var$river.y);
        const bitangents = (0, $820877bea407f5fe$export$13bc7c8899bb5b77)(tangents, $35da740d59af89ba$var$river.curvature, $35da740d59af89ba$var$MAX_VECTOR_LENGTH);
        $35da740d59af89ba$var$slopeVectors = [];
        for(let i = 0; i < $35da740d59af89ba$var$river.x.length; i++){
            const v = $35da740d59af89ba$var$blendVectors($35da740d59af89ba$var$river, i, tangents[i], bitangents[i]);
            $35da740d59af89ba$var$river.x[i] -= v[0];
            $35da740d59af89ba$var$river.y[i] -= v[1];
        }
    }
    (0, $450fab56b0cbf5ba$export$f34ba8b5435301be)($35da740d59af89ba$var$river);
}
window.n = {
    min: Infinity,
    max: -Infinity
};
function $35da740d59af89ba$var$computeNoiseField() {
    const { width: width, height: height } = $35da740d59af89ba$var$canvas;
    if (width === $35da740d59af89ba$var$lastNoiseWidth && height === $35da740d59af89ba$var$lastNoiseHeight && (!$35da740d59af89ba$var$DRAW_NOISE || $35da740d59af89ba$var$cachedNoiseImage)) return;
    const noiseValues = new Array(height);
    console.time("computeNoiseField - terrain");
    for(let x = Math.floor($35da740d59af89ba$var$bounds.minX); x < Math.ceil($35da740d59af89ba$var$bounds.maxX); x++)for(let y = Math.floor($35da740d59af89ba$var$bounds.minY); y < Math.ceil($35da740d59af89ba$var$bounds.maxY); y++)$35da740d59af89ba$var$terrain.getElevation(x, y);
    console.timeEnd("computeNoiseField - terrain");
    console.time("computeNoiseField - noise");
    // Store noise values
    for(let y = 0; y < height; y++){
        noiseValues[y] = new Array(width);
        for(let x = 0; x < width; x++){
            const worldPos = $35da740d59af89ba$var$worldCanvas.toWorld(x, y);
            let finalNoise = $35da740d59af89ba$var$terrain.getElevation(worldPos.x, worldPos.y);
            noiseValues[y][x] = finalNoise;
        }
    }
    console.timeEnd("computeNoiseField - noise");
    // Create debug visualization if needed
    if ($35da740d59af89ba$var$DRAW_NOISE) {
        const imageData = $35da740d59af89ba$var$ctx.createImageData(width, height);
        const data = imageData.data;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const index = (y * width + x) * 4;
            const elevation = noiseValues[y][x];
            if (elevation > 0.2) {
                data[index] = 255;
                data[index + 1] = 0;
                data[index + 2] = 0;
            } else if (elevation > -0.01 && elevation < 0.01) {
                data[index] = 0;
                data[index + 1] = 255;
                data[index + 2] = 0;
            } else {
                // min = -3
                // max = 0.2
                const normalized = (elevation + 3) / 3.2;
                const quantized = Math.round(normalized * 20) / 20;
                const color = quantized * 255;
                data[index] = color;
                data[index + 1] = color;
                data[index + 2] = color;
            }
            data[index + 3] = 255;
        }
        $35da740d59af89ba$var$cachedNoiseImage = imageData;
    }
    console.time("computeNoiseField - contours");
    // Compute contours
    $35da740d59af89ba$var$computeContours(noiseValues, width, height);
    console.timeEnd("computeNoiseField - contours");
    $35da740d59af89ba$var$lastNoiseWidth = width;
    $35da740d59af89ba$var$lastNoiseHeight = height;
}
function $35da740d59af89ba$var$drawErosion(ctx) {
    if (!$35da740d59af89ba$var$DRAW_EROSION) return;
    const { width: width, height: height } = $35da740d59af89ba$var$canvas;
    const imageData = ctx.createImageData(width, height);
    const data = imageData.data;
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const worldPos = $35da740d59af89ba$var$worldCanvas.toWorld(x, y);
        const erosion = $35da740d59af89ba$var$terrain.getErosion(worldPos.x, worldPos.y);
        const aggradation = $35da740d59af89ba$var$terrain.getAggradation(worldPos.x, worldPos.y);
        const index = (y * width + x) * 4;
        if (aggradation + erosion < 5) {
            data[index] = 247;
            data[index + 1] = 251;
            data[index + 2] = 232;
            data[index + 3] = 255;
        } else if (aggradation > erosion) {
            const n = Math.min(255, aggradation / 10 * 255);
            data[index] = n;
            data[index + 1] = n;
            data[index + 2] = n;
            data[index + 3] = n;
        } else {
            const n = 255 - Math.min(erosion / 10 * 255);
            data[index] = n;
            data[index + 1] = n;
            data[index + 2] = n;
            data[index + 3] = 255;
        }
    }
    ctx.putImageData(imageData, 0, 0);
}
function $35da740d59af89ba$var$drawDebugNoise(ctx) {
    if (!$35da740d59af89ba$var$DRAW_NOISE) return;
    if ($35da740d59af89ba$var$cachedNoiseImage) ctx.putImageData($35da740d59af89ba$var$cachedNoiseImage, 0, 0);
}
function $35da740d59af89ba$var$computeContours(noiseValues, width, height) {
    $35da740d59af89ba$var$cachedContours = [];
    for(let threshold = 0.2; threshold <= 1; threshold += $35da740d59af89ba$var$CONTOUR_INTERVAL){
        const contourPaths = [];
        for(let y = 0; y < height - 1; y++)for(let x = 0; x < width - 1; x++){
            const cell = [
                noiseValues[y][x],
                noiseValues[y][x + 1],
                noiseValues[y + 1][x + 1],
                noiseValues[y + 1][x]
            ];
            const segments = $35da740d59af89ba$var$getContourSegments(x, y, cell, threshold);
            if (segments.length > 0) contourPaths.push(...segments);
        }
        if (contourPaths.length > 0) $35da740d59af89ba$var$cachedContours.push({
            threshold: threshold,
            paths: contourPaths
        });
    }
}
function $35da740d59af89ba$var$drawContours(ctx) {
    if (!$35da740d59af89ba$var$DRAW_CONTOURS) return;
    if (!$35da740d59af89ba$var$cachedContours) return;
    ctx.lineWidth = 1;
    for (const contour of $35da740d59af89ba$var$cachedContours){
        ctx.strokeStyle = $35da740d59af89ba$var$interpolateColor($35da740d59af89ba$var$COLORS.WHITE, $35da740d59af89ba$var$COLORS.BLACK, contour.threshold);
        // if (contour.threshold > 0.75 && contour.threshold - 0.75 < 0.01) {
        //   ctx.strokeStyle = "red";
        //   ctx.lineWidth = 3;
        // }
        ctx.beginPath();
        for (const segment of contour.paths){
            ctx.moveTo(segment.x1, segment.y1);
            ctx.lineTo(segment.x2, segment.y2);
        }
        ctx.stroke();
    }
}
function $35da740d59af89ba$var$getContourSegments(x, y, cell, threshold) {
    let squareIndex = 0;
    if (cell[0] > threshold) squareIndex |= 1;
    if (cell[1] > threshold) squareIndex |= 2;
    if (cell[2] > threshold) squareIndex |= 4;
    if (cell[3] > threshold) squareIndex |= 8;
    const segments = [];
    // Linear interpolation between two values
    const interpolate = (v1, v2)=>{
        if (v1 === v2) return 0.5;
        return (threshold - v1) / (v2 - v1);
    };
    // Helper to add a segment
    const addSegment = (x1, y1, x2, y2)=>{
        segments.push({
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        });
    };
    // Interpolate edge points
    const left = interpolate(cell[0], cell[3]);
    const right = interpolate(cell[1], cell[2]);
    const top = interpolate(cell[0], cell[1]);
    const bottom = interpolate(cell[3], cell[2]);
    switch(squareIndex){
        case 1:
        case 14:
            addSegment(x, y + left, x + top, y);
            break;
        case 2:
        case 13:
            addSegment(x + top, y, x + 1, y + right);
            break;
        case 3:
        case 12:
            addSegment(x, y + left, x + 1, y + right);
            break;
        case 4:
        case 11:
            addSegment(x + 1, y + right, x + bottom, y + 1);
            break;
        case 5:
            addSegment(x, y + left, x + top, y);
            addSegment(x + 1, y + right, x + bottom, y + 1);
            break;
        case 6:
        case 9:
            addSegment(x + top, y, x + bottom, y + 1);
            break;
        case 7:
        case 8:
            addSegment(x, y + left, x + bottom, y + 1);
            break;
        case 10:
            addSegment(x + top, y, x + 1, y + right);
            addSegment(x, y + left, x + bottom, y + 1);
            break;
        case 15:
        case 0:
            break;
    }
    return segments;
}
const $35da740d59af89ba$var$animation = new (0, $fdaf2b585cf7a8ba$export$1f1fba5c4d5199c6)();
function $35da740d59af89ba$var$prepareFrame(currentTime) {
    const frameState = $35da740d59af89ba$var$animation.prepareFrame(currentTime);
    if (!frameState) return false;
    const { steps: steps, adjustedTime: adjustedTime } = frameState;
    if (steps > 0) {
        while($35da740d59af89ba$var$animation.frame < $35da740d59af89ba$var$SKIP_N_FRAMES / $35da740d59af89ba$var$MAX_VECTOR_LENGTH){
            $35da740d59af89ba$var$animation.frame++;
            $35da740d59af89ba$var$updateRiver();
        }
        for(let s = 0; s < steps; s++)$35da740d59af89ba$var$updateRiver();
        if ($35da740d59af89ba$var$PRINT_ANIMATION_FRAME) console.log({
            frame: $35da740d59af89ba$var$animation.frame
        });
        $35da740d59af89ba$var$animation.postUpdate(steps);
        if ($35da740d59af89ba$var$animation.frame >= window.stopAtAnimationFrame) $35da740d59af89ba$var$animation.isPaused = true;
    }
    $35da740d59af89ba$var$ctx.fillStyle = $35da740d59af89ba$var$rgb($35da740d59af89ba$var$COLORS.BACKGROUND);
    $35da740d59af89ba$var$ctx.fillRect(0, 0, $35da740d59af89ba$var$canvas.width, $35da740d59af89ba$var$canvas.height);
    $35da740d59af89ba$var$computeNoiseField();
    $35da740d59af89ba$var$drawDebugNoise($35da740d59af89ba$var$ctx);
    $35da740d59af89ba$var$drawErosion($35da740d59af89ba$var$ctx);
    $35da740d59af89ba$var$drawContours($35da740d59af89ba$var$ctx);
    if ($35da740d59af89ba$var$DRAW_SLOPE) $35da740d59af89ba$var$slopeVectors.forEach(({ slope: slope, x: x, y: y })=>{
        const vs = 100;
        const point = $35da740d59af89ba$var$worldCanvas.toScreen(x, y);
        const vector = $35da740d59af89ba$var$worldCanvas.vectorToScreen(slope[0], slope[1]);
        $35da740d59af89ba$var$ctx.beginPath();
        $35da740d59af89ba$var$ctx.strokeStyle = "#ff0000";
        $35da740d59af89ba$var$ctx.lineWidth = 1;
        $35da740d59af89ba$var$ctx.moveTo(point.x, point.y);
        $35da740d59af89ba$var$ctx.lineTo(point.x + vector.x * vs, point.y + vector.y * vs);
        $35da740d59af89ba$var$ctx.stroke();
    });
    return {
        adjustedTime: adjustedTime
    };
}
function $35da740d59af89ba$var$drawIntersections(ctx, intersections, segment) {
    if ($35da740d59af89ba$var$DRAW_INTERSECTIONS) {
        ctx.strokeStyle = "#ff0000";
        ctx.lineWidth = 2;
        const boxSize = 20;
        for (const point of $35da740d59af89ba$var$worldCanvas.transformPoints(intersections))ctx.strokeRect(point.x - boxSize / 2, point.y - boxSize / 2, boxSize, boxSize);
        const startPoint = $35da740d59af89ba$var$worldCanvas.toScreen($35da740d59af89ba$var$river.x[segment.start], $35da740d59af89ba$var$river.y[segment.start]);
        const endPoint = $35da740d59af89ba$var$worldCanvas.toScreen($35da740d59af89ba$var$river.x[segment.end], $35da740d59af89ba$var$river.y[segment.end]);
        ctx.strokeStyle = "#00ff00";
        ctx.lineWidth = 2;
        ctx.strokeRect(startPoint.x - boxSize / 2, startPoint.y - boxSize / 2, boxSize, boxSize);
        ctx.strokeStyle = "#0000ff";
        ctx.lineWidth = 2;
        ctx.strokeRect(endPoint.x - boxSize / 2, endPoint.y - boxSize / 2, boxSize, boxSize);
    //   const loopPoints = extractLoop(channels, segment);
    //   // Only draw if we have a valid loop
    //   if (loopPoints && loopPoints.length > 2 && loopPoints.length < 500) {
    //     ctx.save();
    //     // Create clipping path for the loop
    //     ctx.beginPath();
    //     ctx.moveTo(loopPoints[0].x, loopPoints[0].y);
    //     for (const point of loopPoints) {
    //       ctx.lineTo(point.x, point.y);
    //     }
    //     ctx.closePath();
    //     // Only fill the actual loop area
    //     ctx.fillStyle = "rgba(0, 255, 0, 0.2)";
    //     ctx.fill();
    //     ctx.restore();
    //   }
    }
}
function $35da740d59af89ba$var$drawRiver(currentTime) {
    const frameState = $35da740d59af89ba$var$prepareFrame(currentTime);
    if (!frameState) return;
    const { adjustedTime: adjustedTime } = frameState;
    let channels = (0, $300d32803541d4a4$export$b3d4e64778df73ab)($35da740d59af89ba$var$river, $35da740d59af89ba$var$worldCanvas);
    // if (animation.frame % 50 === 49) {
    //   cachedContours = null;
    //   // cachedNoiseImage = null;
    //   // noiseValues = null;
    //   lastNoiseWidth++;
    // }
    if ($35da740d59af89ba$var$animation.frame % $35da740d59af89ba$var$SAVE_HIST_EVERY === 0 && $35da740d59af89ba$var$DRAW_HIST) {
        $35da740d59af89ba$var$river.hist.push({
            time: currentTime,
            channels: channels,
            type: "channel",
            coords: "world"
        });
        if ($35da740d59af89ba$var$river.hist.length > 500) $35da740d59af89ba$var$river.hist.shift();
    }
    for(let channel = 0; channel < 2; channel++){
        let { intersections: intersections, intersectionSegments: intersectionSegments } = (0, $820877bea407f5fe$export$9ab8d65b20cc4c12)(channels[channel], $35da740d59af89ba$var$river.hist.filter((h)=>h.type === "cutoff"));
        intersectionSegments.forEach((segment)=>{
            $35da740d59af89ba$var$drawIntersections($35da740d59af89ba$var$ctx, intersections, segment);
        });
        intersectionSegments = intersectionSegments.filter((s)=>s.type === "self");
        let segment;
        while(segment = intersectionSegments.pop()){
            if (segment.end - segment.start < 20) continue;
            const loopPoints = (0, $450fab56b0cbf5ba$export$279b7ad781fbe41)(channels[channel], segment);
            const remove = loopPoints && loopPoints.length > 10 && loopPoints.length < 500;
            // if (!isPaused) console.log({ frame, remove, segment, loopPoints });
            if (remove) {
                $35da740d59af89ba$var$river = (0, $450fab56b0cbf5ba$export$8f14948c2269a69b)($35da740d59af89ba$var$river, segment, currentTime);
                $35da740d59af89ba$var$updateRiver(false);
                channels = (0, $300d32803541d4a4$export$b3d4e64778df73ab)($35da740d59af89ba$var$river, $35da740d59af89ba$var$worldCanvas);
                ({ intersections: intersections, intersectionSegments: intersectionSegments } = (0, $820877bea407f5fe$export$9ab8d65b20cc4c12)(channels[channel]));
                intersectionSegments = intersectionSegments.filter((s)=>s.type === "self");
            }
        }
    }
    if ($35da740d59af89ba$var$DRAW_HIST) $35da740d59af89ba$var$river.hist.forEach((hist, i)=>{
        const factor1 = $35da740d59af89ba$var$getFactor(hist.time, adjustedTime);
        if (factor1 < 0.01) return;
        if ($35da740d59af89ba$var$DRAW_CUTOFFS && hist.type === "cutoff") {
            if (!hist._cachedPaths) hist._cachedPaths = (0, $300d32803541d4a4$export$b3d4e64778df73ab)(hist, $35da740d59af89ba$var$worldCanvas);
            hist._cachedPaths.forEach((points)=>{
                const fillColor = $35da740d59af89ba$var$getColor(hist.time, adjustedTime, $35da740d59af89ba$var$COLORS.INACTIVE_CHANNEL, $35da740d59af89ba$var$COLORS.ACTIVE_CHANNEL);
                const strokeColor = $35da740d59af89ba$var$getColor(hist.time, adjustedTime, $35da740d59af89ba$var$COLORS.OUTLINE, $35da740d59af89ba$var$COLORS.FADE_COLOR);
                $35da740d59af89ba$var$renderChannel($35da740d59af89ba$var$ctx, points, fillColor, strokeColor);
                if ($35da740d59af89ba$var$SHORTEN_CUTOFFS) {
                    factor1 = $35da740d59af89ba$var$getFactor(hist.time, adjustedTime) * 2;
                    hist.x = $35da740d59af89ba$var$getMiddlePortion(hist.x, factor1);
                    hist.y = $35da740d59af89ba$var$getMiddlePortion(hist.y, factor1);
                    if (hist.x.length < 3) $35da740d59af89ba$var$river.hist.splice(i, 1);
                }
            });
        } else if ($35da740d59af89ba$var$DRAW_CHANNELS && hist.type === "channel") hist.channels.forEach((channel)=>{
            const fillColor = $35da740d59af89ba$var$getColor(hist.time, adjustedTime, $35da740d59af89ba$var$COLORS.ACTIVE_CHANNEL, $35da740d59af89ba$var$COLORS.FADE_COLOR);
            const strokeColor = $35da740d59af89ba$var$getColor(hist.time, adjustedTime, $35da740d59af89ba$var$COLORS.OUTLINE, $35da740d59af89ba$var$COLORS.FADE_COLOR);
            $35da740d59af89ba$var$renderChannel($35da740d59af89ba$var$ctx, channel, fillColor, strokeColor);
        });
    });
    if ($35da740d59af89ba$var$DRAW_RIVER) channels.forEach((channel)=>{
        $35da740d59af89ba$var$renderChannel($35da740d59af89ba$var$ctx, channel, $35da740d59af89ba$var$rgb($35da740d59af89ba$var$COLORS.ACTIVE_CHANNEL), $35da740d59af89ba$var$rgb($35da740d59af89ba$var$COLORS.OUTLINE));
    });
    if ($35da740d59af89ba$var$DRAW_VECTORS) $35da740d59af89ba$var$drawVectorsDebug($35da740d59af89ba$var$ctx);
    if ($35da740d59af89ba$var$SHOW_FPS) {
        $35da740d59af89ba$var$ctx.font = "16px monospace";
        $35da740d59af89ba$var$ctx.fillStyle = $35da740d59af89ba$var$rgb($35da740d59af89ba$var$COLORS.BLACK);
        $35da740d59af89ba$var$ctx.fillText(`FPS: ${$35da740d59af89ba$var$animation.currentFps}`, 10, 20);
    }
    if (!$35da740d59af89ba$var$endInitTime) {
        $35da740d59af89ba$var$endInitTime = Date.now();
        console.log("init time", $35da740d59af89ba$var$endInitTime - $35da740d59af89ba$var$initTime);
    }
    $35da740d59af89ba$var$animation.req = requestAnimationFrame($35da740d59af89ba$var$drawRiver);
}
function $35da740d59af89ba$var$renderChannel(ctx, channel, fillColor, strokeColor, lineWidth = 1, close = false) {
    if (channel.length === 0) return;
    if (Array.isArray(channel[0])) {
        channel.forEach((island)=>{
            $35da740d59af89ba$var$renderChannel(ctx, island, $35da740d59af89ba$var$rgb($35da740d59af89ba$var$COLORS.BACKGROUND), $35da740d59af89ba$var$rgb($35da740d59af89ba$var$COLORS.OUTLINE), 0.5, true);
        });
        return;
    }
    const sx = $35da740d59af89ba$var$worldCanvas.startX;
    const sy = $35da740d59af89ba$var$worldCanvas.startY;
    const sc = $35da740d59af89ba$var$worldCanvas.scale;
    // Fill — inline transform, no intermediate array
    ctx.beginPath();
    ctx.fillStyle = fillColor;
    ctx.moveTo(sx + channel[0].x * sc, sy + channel[0].y * sc);
    for(let i = 1; i < channel.length; i++)ctx.lineTo(sx + channel[i].x * sc, sy + channel[i].y * sc);
    ctx.closePath();
    ctx.fill();
    // Stroke — segmented by gap, inline transform
    ctx.beginPath();
    ctx.strokeStyle = strokeColor;
    ctx.lineWidth = lineWidth;
    let segStarted = false;
    for(let i = 0; i < channel.length; i++){
        const g = channel[i].gap;
        const px = sx + channel[i].x * sc;
        const py = sy + channel[i].y * sc;
        if (g === undefined) {
            if (!segStarted) ctx.moveTo(px, py);
            else ctx.lineTo(px, py);
            if (close) ctx.closePath();
            segStarted = false;
        } else if (g > 0) {
            if (!segStarted) {
                ctx.moveTo(px, py);
                segStarted = true;
            } else ctx.lineTo(px, py);
        } else {
            if (segStarted && close) ctx.closePath();
            segStarted = false;
        }
    }
    if (segStarted && close) ctx.closePath();
    ctx.stroke();
}
const $35da740d59af89ba$var$interpolateColor = (c1, c2, factor1)=>{
    const r = Math.round(c1[0] * (1 - factor1) + c2[0] * factor1);
    const g = Math.round(c1[1] * (1 - factor1) + c2[1] * factor1);
    const b = Math.round(c1[2] * (1 - factor1) + c2[2] * factor1);
    return `rgb(${r}, ${g}, ${b})`;
};
const $35da740d59af89ba$var$getFactor = (time, currentTime)=>Math.min(1, Math.max(0, time / currentTime));
const $35da740d59af89ba$var$getColor = (time, currentTime, baseColor, fadeColor)=>{
    const factor1 = $35da740d59af89ba$var$getFactor(time, currentTime);
    return $35da740d59af89ba$var$interpolateColor(fadeColor, baseColor, factor1);
};
function $35da740d59af89ba$var$drawVectorsDebug(ctx) {
    const tangents = (0, $820877bea407f5fe$export$15356c20484a5e31)($35da740d59af89ba$var$river.x, $35da740d59af89ba$var$river.y);
    const curvature = (0, $820877bea407f5fe$export$ae00d55f457928e)($35da740d59af89ba$var$river.x, $35da740d59af89ba$var$river.y);
    const bitangents = (0, $820877bea407f5fe$export$13bc7c8899bb5b77)(tangents, curvature, $35da740d59af89ba$var$MAX_VECTOR_LENGTH);
    const blendedVectors = $35da740d59af89ba$var$river.x.map((x, i)=>$35da740d59af89ba$var$blendVectors($35da740d59af89ba$var$river, i, tangents[i], bitangents[i]));
    (0, $820877bea407f5fe$export$87efdedd59138619)(ctx, $35da740d59af89ba$var$river.x.map((x)=>$35da740d59af89ba$var$worldCanvas.toScreen(x, 0).x), $35da740d59af89ba$var$river.y.map((y)=>$35da740d59af89ba$var$worldCanvas.toScreen(0, y).y), blendedVectors, "#0000ff");
    (0, $820877bea407f5fe$export$ad7ddb6ad05f982e)(ctx, $35da740d59af89ba$var$river.x.map((x)=>$35da740d59af89ba$var$worldCanvas.toScreen(x, 0).x), $35da740d59af89ba$var$river.y.map((y)=>$35da740d59af89ba$var$worldCanvas.toScreen(0, y).y), tangents, "#ff0000");
}
function $35da740d59af89ba$var$getMiddlePortion(xs, percentage) {
    if (!Array.isArray(xs) || xs.length === 0) return [];
    if (percentage > 1) return xs;
    if (percentage <= 0 || percentage > 1) throw new Error("Percentage must be between 0 and 1");
    const totalLength = xs.length;
    const portionLength = Math.round(totalLength * percentage);
    if (totalLength - portionLength < 2) return xs;
    const startIndex = Math.round((totalLength - portionLength) / 2);
    const endIndex = startIndex + portionLength;
    console.log({
        factor: factor,
        startIndex: startIndex,
        endIndex: endIndex
    });
    return xs.slice(startIndex, endIndex);
}
function $35da740d59af89ba$var$resetAnimationState() {
    $35da740d59af89ba$var$animation.reset();
    $35da740d59af89ba$var$cachedNoiseImage = null;
    $35da740d59af89ba$var$cachedContours = null;
    $35da740d59af89ba$var$lastNoiseWidth = 0;
    $35da740d59af89ba$var$lastNoiseHeight = 0;
}
// Add debounced resize handler
let $35da740d59af89ba$var$resizeTimeout;
function $35da740d59af89ba$var$handleResize(immediate = false) {
    const resize = ()=>{
        $35da740d59af89ba$var$canvas.width = window.innerWidth;
        $35da740d59af89ba$var$canvas.height = window.innerHeight;
        $35da740d59af89ba$var$bounds = $35da740d59af89ba$var$computeBounds($35da740d59af89ba$var$river.x, $35da740d59af89ba$var$river.y);
        $35da740d59af89ba$var$worldCanvas.updateBounds($35da740d59af89ba$var$bounds);
        $35da740d59af89ba$var$resetAnimationState();
        $35da740d59af89ba$var$drawRiver(performance.now());
    };
    if (immediate) resize();
    else {
        if ($35da740d59af89ba$var$resizeTimeout) clearTimeout($35da740d59af89ba$var$resizeTimeout);
        $35da740d59af89ba$var$resizeTimeout = setTimeout(resize, 250); // 250ms debounce
    }
}
// Initial setup
$35da740d59af89ba$var$generateRiver();
$35da740d59af89ba$var$handleResize(true); // Pass true for immediate resize
$35da740d59af89ba$var$animation.req = requestAnimationFrame($35da740d59af89ba$var$drawRiver);
window.addEventListener("resize", ()=>$35da740d59af89ba$var$handleResize(false));


//# sourceMappingURL=index.462969ef.js.map
